import {
  CONTENT_RECOMMENDATIONS_EXCEL_EXPORT_META,
  BORDER_PROPERTIES,
  DATA_ROW_PROPERTIES,
} from '../constants/formMeta/growthTrends';
import { TOPIC_BODY_TAGS } from '../constants/common';
import { orderBy } from 'lodash';

export const addUrl = (worksheet, url, formatting) => {
  const { top_header } = CONTENT_RECOMMENDATIONS_EXCEL_EXPORT_META;
  const { cust_url } = top_header;
  worksheet.mergeCells(cust_url.start_cell, cust_url.end_cell);
  worksheet.getCell(cust_url.end_cell).value = url;
  const row1 = worksheet.getRow(cust_url.row);
  row1.eachCell((cell) => {
    cell.border = BORDER_PROPERTIES;
    cell.font = DATA_ROW_PROPERTIES.font;
    cell.fill = DATA_ROW_PROPERTIES.fill;
    cell.alignment = formatting.alignment;
  });
};

export function topicsDataForExcel(getTopicsData, topicsAllHtmlData, mappedTopicsData = [], isPublishHistory = false) {
  const allTopics = isPublishHistory ? getTopicsData(mappedTopicsData) : getTopicsData();
  const topicsData = [];
  let foundObj, siblingsDataArr, foundSiblingObj;
  if (allTopics?.length) {
    allTopics.forEach((topic) => {
      const topicWiseData = [];
      topic.CONTENT.forEach((rawHtmlContent) => {
        foundObj = topicsAllHtmlData.find((o) => o.id == rawHtmlContent.html_id);
        siblingsDataArr = [];
        if (foundObj) {
          foundObj.siblings &&
            foundObj.siblings.length &&
            foundObj.siblings.forEach((siblingObj) => {
              foundSiblingObj = topicsAllHtmlData.find((o) => o.id == siblingObj.id);
              if (foundSiblingObj && TOPIC_BODY_TAGS.includes(foundSiblingObj.tag.toUpperCase())) {
                const isBodySuggested = foundObj ? (foundObj.isSuggested ? true : false) : false;
                siblingsDataArr.push({
                  updateStatus: getStatusText(foundSiblingObj?.updated_on, isBodySuggested),
                  body_tag: foundSiblingObj.tag,
                  body_text: foundSiblingObj.text,
                  isSuggested: isBodySuggested,
                  is_duplicate: foundSiblingObj.is_duplicate,
                  isEdited: foundSiblingObj.updated_on,
                  created_on: foundSiblingObj?.created_on,
                  updated_on: foundSiblingObj?.updated_on,
                  text_original: foundObj ? (foundObj.text_original ? true : false) : false,
                });
              }
            });
          const isHeadingSuggested = foundObj ? (foundObj.isSuggested ? true : false) : false;
          topicWiseData.push({
            updateStatus: getStatusText(foundObj?.updated_on, isHeadingSuggested),
            heading_tag: foundObj.tag,
            heading_content: foundObj.text,
            body: siblingsDataArr,
            url: rawHtmlContent.url,
            created_on: foundObj?.created_on,
            updated_on: foundObj?.created_by,
            isEdited: foundObj?.updated_on,
            text_original: foundObj ? (foundObj.text_original ? true : false) : false,
            isSuggested: isHeadingSuggested,
          });
        }
      });
      const foundObject = topicsAllHtmlData.find((o) => o.text == topic.TOPIC);

      topicsData.push({
        headings: topicWiseData,
        topic_id: topic.TOPIC_ID,
        topic_name: topic.TOPIC,
        created_on: foundObject?.created_on,
        updated_on: foundObject?.created_by,
        topic_importance_score: Math.ceil(topic.TOPIC_IMPORTANCE),
        text_original: foundObject ? (foundObject.text_original ? true : false) : false,
        isSuggested: foundObject ? (foundObject.isSuggested ? true : false) : false,
        isEdited: foundObject?.updated_on,
      });
    });
  }
  return orderBy(topicsData, ['topic_importance_score'], ['desc']);
}

export function getStatusText(isEdited, isSuggested) {
  return isEdited && !isSuggested ? 'Improved' : isSuggested ? 'Proposed' : '';
}
